import React from 'react';
import { GiftIcon } from 'lucide-react';
import { Eyebrow } from './ui/Eyebrow';
import { CtaButton } from './ui/CtaButton';
import { bonuses, PRICE_LABEL } from '../data/content';
export function BonusSection() {
  const [featured, ...rest] = bonuses;
  return <section className="border-b border-line bg-sand" data-id="element-19" data-mp="22dahutok8dtt">
      <div className="mx-auto max-w-6xl px-5 py-20 lg:py-24" data-id="element-20" data-mp="1yfcr3mf55job">
        <div className="max-w-2xl" data-id="element-21" data-mp="1ao7ah51dmncy">
          <Eyebrow data-id="element-22" data-mp="1ap8q7mtc7y10">Incluido hoy sin costo extra</Eyebrow>
          <h2 className="mt-4 font-display text-3xl font-semibold leading-tight text-ink sm:text-4xl" data-id="element-23" data-mp="15pmdrflc2lt9">
            Los bonos irresistibles
          </h2>
          <p className="mt-5 text-[15px] leading-relaxed text-ink-soft" data-id="element-24" data-mp="1jic1ppkfa0t0">
            Seis regalos que resuelven lo que ningún método toca: diagnóstico del alumno,
            seguimiento del progreso, calentamientos, motivación, correcciones en clase y 10
            tablaturas listas para tocar.
          </p>
        </div>

        <div className="mt-12 grid gap-6 lg:grid-cols-[1.15fr_0.85fr]" data-id="element-25" data-mp="mx1w6ub3434r">
          <article className="flex h-full flex-col overflow-hidden rounded-2xl border border-gold/30 bg-gold-soft" data-id="element-26" data-mp="29rta5kby762b">
            <div className="grid gap-6 p-6 sm:grid-cols-[minmax(0,200px)_1fr] sm:items-start sm:p-8" data-id="element-27" data-mp="2ep3b9x8p965z">
              <img src={featured.cover} alt={`Portada del bono: ${featured.title}`} className="w-full rounded-xl border border-gold/20 object-cover shadow-card" loading="lazy" data-id="element-28" data-mp="2jk8swjv2jyo9" />
              <div className="flex h-full flex-col" data-id="element-29" data-mp="1vtd7c4h7hzpg">
                <div className="flex items-baseline justify-between gap-4" data-id="element-30" data-mp="20reogjv2noya">
                  <span className="text-[11px] font-semibold uppercase tracking-eyebrow text-gold" data-id="element-31" data-mp="20thm9q2gumdk">
                    Bono {featured.number}
                  </span>
                  <span className="text-[11px] font-semibold uppercase tracking-eyebrow text-gold" data-id="element-32" data-mp="3c5s6h8359a6e">
                    {featured.value}
                  </span>
                </div>
                <h3 className="mt-4 font-display text-2xl font-semibold leading-tight text-ink sm:text-[28px]" data-id="element-33" data-mp="1h2m1j4w6vdvf">
                  {featured.title}
                </h3>
                <p className="mt-3 text-[15px] leading-relaxed text-ink-soft" data-id="element-34" data-mp="1q43e4dae0xfd">
                  {featured.description}
                </p>
                <p className="mt-auto flex items-center gap-2 pt-6 text-xs uppercase tracking-eyebrow text-ink-mute" data-id="element-35" data-mp="1m3jl9lwukfz1">
                  <GiftIcon aria-hidden="true" className="h-3.5 w-3.5" data-id="element-36" data-mp="ydfe54kg9y3a" />
                  PDF enviado a tu email
                </p>
              </div>
            </div>
          </article>

          <ul className="grid gap-4" data-id="element-37" data-mp="1760vqhcchyqj">
            {rest.map(bonus => <li key={bonus.number} className="flex gap-4 rounded-xl border border-line bg-paper p-4 sm:p-5" data-id="element-38" data-mp="12e93819mpixr">
                <img src={bonus.cover} alt={`Portada del bono: ${bonus.title}`} className="h-24 w-24 shrink-0 rounded-lg border border-line object-cover" loading="lazy" data-id="element-39" data-mp="emk524a4m08w" />
                <div className="min-w-0" data-id="element-40" data-mp="5awjep8500fe">
                  <div className="flex items-baseline justify-between gap-3" data-id="element-41" data-mp="5bxwt0cmkz0a">
                    <span className="text-[11px] font-semibold uppercase tracking-eyebrow text-ink-mute" data-id="element-42" data-mp="3msfpe4csi0rl">
                      Bono {bonus.number}
                    </span>
                    <span className="shrink-0 text-[11px] font-semibold uppercase tracking-eyebrow text-gold" data-id="element-43" data-mp="jb7bfvl6nl25">
                      {bonus.value}
                    </span>
                  </div>
                  <h3 className="mt-2 font-display text-[17px] font-semibold leading-snug text-ink" data-id="element-44" data-mp="9awvw4boe1jt">
                    {bonus.title}
                  </h3>
                  <p className="mt-1.5 text-sm leading-relaxed text-ink-soft" data-id="element-45" data-mp="2u1xggmpdx569">
                    {bonus.description}
                  </p>
                </div>
              </li>)}
          </ul>
        </div>

        <div className="mt-10 flex flex-col gap-6 rounded-2xl border border-ink/10 bg-paper p-8 lg:flex-row lg:items-center lg:justify-between" data-id="element-46" data-mp="3f8esivhk0qto">
          <div className="max-w-xl" data-id="element-47" data-mp="3ag545jw37yti">
            <h3 className="font-display text-2xl font-semibold text-ink" data-id="element-48" data-mp="35i3m92aee5jm">
              Los 6 bonos, gratis para vos
            </h3>
            <p className="mt-2 text-[15px] leading-relaxed text-ink-soft" data-id="element-49" data-mp="30klcj9ok3mak">
              Todos los bonos vienen incluidos con el pack hoy — todos en PDF, enviados a tu
              email. Sin upsells, sin costos extra.
            </p>
          </div>
          <div className="lg:w-72 lg:shrink-0" data-id="element-50" data-mp="3o8ushuz39fts">
            <CtaButton size="md" data-id="element-51" data-mp="3o7jpvyhdqe49">Reservá el pack por {PRICE_LABEL}</CtaButton>
          </div>
        </div>
      </div>
    </section>;
}